import type { ChangeEvent, FC } from 'react';
import { observer } from 'mobx-react-lite';
import clsx from 'clsx';
import { TextFieldBaseLong, type TextFieldElement } from '@sbol/nova';
import styles from './TextInput.module.scss';

interface Props {
  onChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  hasWarning?: boolean;
  value?: string;
  maxLength?: number;
  className?: string | null;
}

export const TextInput: FC<Props> = observer(({ onChange, value, placeholder, disabled, hasWarning, maxLength, className }) => {
  const handleChange = (e: ChangeEvent<TextFieldElement>) => {
    onChange?.(e.target.value);
  };

  return (
    <TextFieldBaseLong
      placeholder={placeholder}
      value={value}
      maxLength={maxLength}
      maxRow={8}
      className={clsx(styles.TextInput, className)}
      onChange={!disabled ? handleChange : undefined}
      disabled={disabled}
      hasWarning={hasWarning}
      allowClear={false}
    />
  );
});
